module.exports = __webpack_public_path__ + "img/20.rain-light.db07e30e.svg";